export const CONSENTS_TITLE = 'Practitioner Consents';
export const STANDING_ORDERS_TITLE = 'Practitioner Standing Orders';
